export default {
	title: "Koło Szczęścia",
	Lucky: "Szczęśliwy",
	wheels: "Koła",
	winningrecord: "Historia Wygranych",
	ActivityRules: "Zasady Aktywności",
	ActivityRulesContent: "Aby uzyskać więcej informacji o losowaniu, skontaktuj się z naszym działem obsługi klienta.",
	award: {
		title: "Gratulacje, wygrałeś!",
		btn: "Odbierz nagrodę"
	},
	noticeItem: "{0} zdobył {1}",
	lotteryDraws: "{0} losowań loterii",
	noAvailableTimes: "Niewystarczająca liczba prób. Skontaktuj się z obsługą klienta.",
	noOpen: "Jeszcze nieotwarte",
	noWinning: "Próbuj dalej",
	ViewALlPrizes: "Zobacz wszystkie nagrody",
	myPrizes: "Moje nagrody",
	share: "Udostępnij znajomemu"
};
